import React from 'react'
import PropTypes from 'prop-types'
import Badge from '../../ui/Badge'
import { categoryBadgeVariant } from '../IssueStatuses/constants'

const HEADING_CLASS = 'tw:px-3 tw:py-2'

const StatusCategoryHeading = ({ data }) => (
  <div className={HEADING_CLASS}>
    <Badge variant={categoryBadgeVariant(data.value)}>{data.label}</Badge>
  </div>
)

StatusCategoryHeading.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }).isRequired
}

export default StatusCategoryHeading
